/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLeadBrokerListItemDto
 */
export interface GetLeadBrokerListItemDto {
    /**
     * Unique identifier of the broker
     * @type {string}
     * @memberof GetLeadBrokerListItemDto
     */
    brokerId: string;
    /**
     * Display label for the broker
     * @type {string}
     * @memberof GetLeadBrokerListItemDto
     */
    label: string;
    /**
     * Broker email address
     * @type {string}
     * @memberof GetLeadBrokerListItemDto
     */
    email?: string;
    /**
     * Broker phone number
     * @type {string}
     * @memberof GetLeadBrokerListItemDto
     */
    phone?: string;
    /**
     * List of branch codes associated with the broker
     * @type {Array<string>}
     * @memberof GetLeadBrokerListItemDto
     */
    branchCodes?: Array<string>;
    /**
     * Number of pending quotes for this broker
     * @type {number}
     * @memberof GetLeadBrokerListItemDto
     */
    pendingQuotesCount?: number;
}

/**
 * Check if a given object implements the GetLeadBrokerListItemDto interface.
 */
export function instanceOfGetLeadBrokerListItemDto(value: object): value is GetLeadBrokerListItemDto {
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function GetLeadBrokerListItemDtoFromJSON(json: any): GetLeadBrokerListItemDto {
    return GetLeadBrokerListItemDtoFromJSONTyped(json, false);
}

export function GetLeadBrokerListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadBrokerListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'brokerId': json['brokerId'],
        'label': json['label'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'branchCodes': json['branchCodes'] == null ? undefined : json['branchCodes'],
        'pendingQuotesCount': json['pendingQuotesCount'] == null ? undefined : json['pendingQuotesCount'],
    };
}

export function GetLeadBrokerListItemDtoToJSON(json: any): GetLeadBrokerListItemDto {
    return GetLeadBrokerListItemDtoToJSONTyped(json, false);
}

export function GetLeadBrokerListItemDtoToJSONTyped(value?: GetLeadBrokerListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brokerId': value['brokerId'],
        'label': value['label'],
        'email': value['email'],
        'phone': value['phone'],
        'branchCodes': value['branchCodes'],
        'pendingQuotesCount': value['pendingQuotesCount'],
    };
}

